import axios from 'axios';
import { eventHub } from '../utils/eventhub';
import Raven from 'raven-js';
import axiosRetry from 'axios-retry';

export const http = axios.create({
  baseURL: process.env.API,
  timeout: 30000,
  // timeout: 5000,

  validateStatus(status) {
    return status >= 200 && status < 500; // default
  },
  headers: {
    'Access-Control-Allow-Origin': '*',
    'Content-Type': 'application/json',
  },
});

let authData = {};

if (localStorage.getItem('vibbra-user') != null) {
  authData = JSON.parse(localStorage.getItem('vibbra-user'));
  http.defaults.headers.common['access-token'] = authData.access_token;
  http.defaults.headers.common.client = authData.client_code;
  http.defaults.headers.common.expiry = authData.expiry;
  http.defaults.headers.common['token-type'] = 'Bearer';
  http.defaults.headers.common.uid = authData.uid;
}

http.interceptors.request.use(
  conf => {
    eventHub.$emit('before-request');
    return conf;
  },
  error => {
    console.log('Erro1: ' + error);
    Raven.captureException(error);
    eventHub.$emit('request-error');
    return Promise.reject(error);
  }
);
http.interceptors.response.use(
  response => {
    eventHub.$emit('after-response');
    if (response.status > 300) {
      if (response.status === 401) {
        response.data.errors.forEach(element => {
          eventHub.$notify(element, 'error');
        });
        eventHub.$emit('unauthorized');
      } else if (response.data.errors.full_messages) {
        let msg = '';
        response.data.errors.full_messages.forEach(element => {
          msg += '<p>' + element + '</p>';
        });
        eventHub.$notify(msg, 'success', { mode: 'html' });
      } else if (response.data.errors === Array) {
        response.data.errors.forEach(element => {
          eventHub.$notify(element, 'info');
        });
      } else {
        eventHub.$notify(response.data.errors, 'info');
      }
    }
    return response;
  },
  error => {
    console.log('Erro2: ' + error.code);
    Raven.captureException(error);
    eventHub.$emit('response-error');
    eventHub.$notify(
      'Opa! Ocorreu um erro não esperado. Recarregue a página e tente novamente.',
      'error'
    );
    if (error.code === 'ECONNABORTED') {
      return Promise.reject('Erro de conexão com servidor');
    }
  }
);

axiosRetry(http, { retries: 3 });



// WEBPACK FOOTER //
// ./src/api/config.js